export default "__VITE_ASSET__CkXeilM9__"